<template>
  <div class="side-edit-content p-5">
    <strong class="title-main">{{ $t('views.seller.integrations.config.edit.title') }}</strong>
    <p class="subtitle d-block mt-3 mb-4">
      {{ $t('views.seller.integrations.config.edit.product') }}:
      <strong> {{ editGroupData?.product_name }}</strong>
    </p>

    <!-- Exibe token -->
    <div :class="isInputError('update_token')" @click="removeError('update_token')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">API Key</strong>
      </div>
      <div class="d-flex bd-highlight">
        <div class="flex-grow-1 bd-highlight">
          <b-form-group id="fieldset-url" label-for="input-url">
            <b-form-input id="input-url" placeholder="Informe o API Key do Circle" class="form-input" v-model="token" @change="updateConnection" trim></b-form-input>
          </b-form-group>
        </div>
      </div>
      <span class="show-error">
        {{ showError('update_token') }}
      </span>
    </div>

    <!-- Exibe comunidades -->
    <div :class="isInputError('update_community')" @click="removeError('update_community')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Comunidade</strong>
      </div>
      <multiselect 
        v-model="community.value"
        :options="community.items" 
        :multiple="false" 
        :show-labels="false"
        :searchable="false"
        :loading="community.loading"
        :disabled="community.block"
        @input="listItemsCircle"
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a comunidade desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <span slot="noResult">Nenhum item encontrado</span>
        <span slot="noOptions">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('update_community') }}</span>
    </div>

    <!-- Exibe grupos de espaços -->
    <div :class="isInputError('update_space_group')" @click="removeError('update_space_group')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Grupos de Espaços <b class="optional">(opcional)</b></strong>
        <a href="#" @click.prevent="selectAll(space_group)" class="select-all float-right">
          {{ space_group?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="space_group.value"
        :options="space_group.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :searchable="true"
        :loading="space_group.loading"
        :disabled="space_group.block"
        :limit-text="limitText" 
        :select-label="'Select'"
        :limit="4" 
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">
            <img :src="isOptionSelected('space_group_edit', props.option.id, null, space_group)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione os grupos de espaços desejados</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <div slot="limit" class="multiselect__tag limit">+{{ space_group?.value?.length - 4 }}</div>
        <span slot="noResult">Nenhum item encontrado</span>
        <span slot="noOptions">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('update_space_group') }}</span>
    </div>

    <!-- Exibe espaços -->
    <div :class="isInputError('update_space')" @click="removeError('update_space')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Espaços <b class="optional">(opcional)</b></strong>
        <a href="#" @click.prevent="selectAll(space)" class="select-all float-right">
          {{ space?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="space.value"
        :options="space.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :searchable="true"
        :loading="space.loading"
        :disabled="space.block"
        :limit-text="limitText" 
        :select-label="'Select'"
        :limit="4" 
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">
            <img :src="isOptionSelected('space_edit', props.option.id, null, space)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione os espaços desejados</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <div slot="limit" class="multiselect__tag limit">+{{ space?.value?.length - 4 }}</div>
        <span slot="noResult">Nenhum item encontrado</span>
        <span slot="noOptions">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('update_space') }}</span>
    </div>

    <!-- Exibe tags -->
    <div :class="isInputError('update_tag')" @click="removeError('update_tag')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Tags <b class="optional">(opcional)</b></strong>
        <a href="#" @click.prevent="selectAll(tag)" class="select-all float-right">
          {{ tag?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="tag.value"
        :options="tag.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :searchable="true"
        :loading="tag.loading"
        :disabled="tag.block"
        :limit-text="limitText" 
        :select-label="'Select'"
        :limit="4" 
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">
            <img :src="isOptionSelected('tag_edit', props.option.id, null, tag)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione as tags desejadas</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <div slot="limit" class="multiselect__tag limit">+{{ tag?.value?.length - 4 }}</div>
        <span slot="noResult">Nenhum item encontrado</span>
        <span slot="noOptions">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('update_tag') }}</span>
    </div>

  </div>
</template>

<script>

import ConnectionService from '@/services/resources/ConnectionService';
import CallbackService from '@/services/resources/CallbackService';
import Multiselect from 'vue-multiselect';
import SwitchGroup from '@/components/shared/forms/SwitchGroup';
import CircleService from "@/services/resources/CircleService";
import ObservabilityService from '@/services/observability/ObservabilityService';

export default {
  name: "IntegrationsConfigUpdateCircle",
  components: {
    Multiselect,
    SwitchGroup
  },
  props: {
    opendEdit: {
      type: Boolean,
      required: true
    },
    loadingUpdate: {
      type: Boolean,
      required: true
    },
    editGroupLoad: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Circle' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    events: {
      type: Object,
      required: true,
      default: () => ({
        options_sales: [],
        options_contracts: [],
        options_sales_recovery: []
      })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    removeError: {
      type: Function,
      required: true
    },
    removeErrors: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
    isOptionSelected: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
    organizeEvents: {
      type: Function,
      required: true
    },
    selectAll: {
      type: Function,
      required: true
    },
  },
  data: () => ({
    editGroupData: {},
    editGroupEvents: [],
    url: 'https://app.circle.so/api/v1',
    token: '',
    community: {
      block: true,
      loading: false,
      value: null,
      items: [],
    },
    space: {
      block: true,
      loading: false,
      value: null,
      items: [],
    },
    space_group: {
      block: true,
      loading: false,
      value: null,
      items: [],
    },
    tag: {
      block: true,
      loading: false,
      value: null,
      items: [],
    },
  }),
  methods: {
    async showEditCallback(data) {

      this.removeErrors([
        'update_token',
        'update_community',
        'update_space',
        'update_space_group',
        'update_tag',
      ]);

      for (const item of ['community', 'space', 'space_group', 'tag']) {
        this[item].block = true;
        this[item].value = null;
      }

      this.editGroupData = data;

      this.$emit('update:opendEdit', true);
      this.$emit('update:editGroupLoad', true);
      this.$emit('update:loadingUpdate', false);
      this.$emit('update:productSelected', data.product_id);

      await this.getIntegrationToken(data.connection.id);
      await this.updateConnection(true);

      this.$emit('update:editGroupLoad', false);
    },
    async getIntegrationToken(id) {
      await ConnectionService.build().read(id, { suppressErrorNotify: true })
      .then(response => {
        const data = JSON.parse(response.data);
        this.token = data.api_key;
      })
      .catch(() => {
        this.mountInputError({
          token: ['Token não encontrado']
        }, 'update_');
      });
    },
    async updateConnection(compare) {

      if (this.token) {
        try {
          await CircleService.build().read(`test?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true });

          this.community.loading = true;
          this.community.block = false;
          this.community.value = [];

          try {
            const response = await CircleService.build().read(`community?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true });

            this.community.items = response.map(item => ({
              id: item.id,
              name: item.name
            }));

            // Se compare, verifica os itens em editGroupData e add os values
            if (compare === true) {
              const selectedValue = this.community.items.find(item => item.id === this.editGroupData?.args?.community_id);
              if(selectedValue) {
                this.community.value = selectedValue;
                this.listItemsCircle(selectedValue, true);
              }
            }
          } catch {
            // Se o fetch de comunidades Circle falhar (ex: token expirado, API instável),
            // o dropdown ficava vazio sem explicação. Log para Sentry + toast consolidado em listItemsCircle.
            this.community.items = [];
            this.community.value = null;
            ObservabilityService.integrationFetchFailed(new Error('Falha ao carregar comunidades'), {
              provider: 'circle',
              resource: 'communities',
            });
          } finally {
            this.community.loading = false;
          }
        } catch (err) {
          this.mountInputError(err.response.data, 'update_');
          const items = ['community', 'space', 'space_group', 'tag'];
          for (const item of items) {
            this[item].block = true;
            this[item].value = [];
          }
        } finally {
          this.community.loading = false;
        }
      }
    },
    async listItemsCircle(selectedValue, compare) {

      if (!selectedValue) {
        const items = ['space', 'space_group', 'tag'];
        for (const item of items) {
          this[item].block = true;
          this[item].value = [];
        }
        return;
      }

      const results = await Promise.all([
        this.listSpacesGroupCircle(selectedValue, compare),
        this.listSpacesCircle(selectedValue, compare),
        this.listTagsCircle(selectedValue, compare)
      ]);

      // Se algum dropdown falhou (items vazio após fetch), exibe toast único
      // ao invés de múltiplos toasts para cada dropdown que falhou.
      const hasEmptyItems = ['space', 'space_group', 'tag'].some(
        item => this[item].items.length === 0 && !this[item].block
      );
      if (hasEmptyItems) {
        this.$bvToast.toast(
          'Não foi possível carregar todos os dados da integração. Verifique o token e tente novamente.',
          {
            title: 'Circle',
            variant: 'warning',
            autoHideDelay: 5000,
            appendToast: true,
          }
        );
      }
    },
    async listSpacesCircle(selectedValue, compare) {

      try {

        this.space.loading = true;
        this.space.block = false;
        this.space.value = [];

        const response = await CircleService.build().read(`community/${selectedValue.id}/spaces?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true });

        this.space.items = response.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        });

        if (compare) {
          this.space.value = this.editGroupData?.args?.spaces;
        }
      }
      catch (err) {
        // Se o fetch de espaços Circle falhar, o dropdown ficava vazio silenciosamente.
        // Log para Sentry; toast consolidado é exibido pelo método pai listItemsCircle.
        this.space.items = [];
        ObservabilityService.integrationFetchFailed(err, {
          provider: 'circle',
          resource: 'spaces',
        });
      }
      finally {
        this.space.loading = false;
      }
    },
    async listSpacesGroupCircle(selectedValue, compare) {

      try {
        this.space_group.loading = true;
        this.space_group.block = false;
        this.space_group.value = [];

        const response = await CircleService.build().read(`community/${selectedValue.id}/space_groups?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true });
        
        this.space_group.items = response.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        });

        if (compare) {
          this.space_group.value = this.editGroupData?.args?.space_groups;
        }
      }
      catch(err) {
        //  Se o fetch de space groups Circle falhar, dropdown ficava vazio silenciosamente.
        // Log para Sentry; toast consolidado é exibido pelo método pai listItemsCircle.
        this.space_group.items = [];
        ObservabilityService.integrationFetchFailed(err, {
          provider: 'circle',
          resource: 'space_groups',
        });
      }
      finally {
        this.space_group.loading = false;
      };
    },
    async listTagsCircle(selectedValue, compare) {

      try {
        this.tag.loading = true;
        this.tag.block = false;
        this.tag.value = [];

        const response = await CircleService.build().read(`community/${selectedValue.id}/tags?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true })
         
        this.tag.items = response.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        });

        if (compare) {
          this.tag.value = this.editGroupData?.args?.tags;
        }
      }
      catch (err) {
        // Se o fetch de tags Circle falhar, dropdown ficava vazio silenciosamente.
        // Log para Sentry; toast consolidado é exibido pelo método pai listItemsCircle.
        this.tag.items = [];
        ObservabilityService.integrationFetchFailed(err, {
          provider: 'circle',
          resource: 'tags',
        });
      }
      finally {
        this.tag.loading = false;
      };
    },
    async updateCallbacks(data) {

      this.$emit('update:loadingUpdate', true);

      try {

        const force = data?.force_update || false;

        const products = (force) ? data.products : data;
        const token = ((force) ? data.dataUpdate.token : this.token) || '';
        const community = ((force) ? data.dataUpdate.community : this.community?.value) || null;
        const spaces = ((force) ? data.dataUpdate.spaces : this.space?.value) || [];
        const space_groups = ((force) ? data.dataUpdate.space_groups : this.space_group?.value) || [];
        const tags = ((force) ? data.dataUpdate.tags : this.tag?.value) || [];

        const promises = products.map(async (product) => {

          const product_id = (force) ? product.product_id : product;
          const connection_id = (force) ? product.connection_id : this.editGroupData.connection.id;
          const callback = (force) ? product.callback : this.editGroupData.callback;

          return CallbackService.build().update({
            connection_id,
            callback,
            url: this.url,
            token,
            events: [{ "trigger": "salePaid" }, { "trigger": "saleRefunded" }], // Venda paga e Venda reembolsada
            community,
            spaces,
            space_groups,
            tags,
            action: {
              value: 'executarCircle',
            }
          }, `integrations/group/${this.integration.id}/${product_id}`, { suppressErrorNotify: true });
        });

        await Promise.all(promises);

        this.$emit('update:opendEdit', false);
        this.fetchCallbacks();

        const message = products.length > 1 ?
          this.$t('views.seller.integrations.config.toast.update.success.message_multiple') :
          this.$t('views.seller.integrations.config.toast.update.success.message');

        this.$bvToast.toast(message, {
          title: this.$t('views.seller.integrations.config.toast.update.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });

      } catch (err) {
        this.mountInputError(err.response.data, 'update_');
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.error.message'), {
            title: this.$t('views.seller.integrations.config.toast.update.error.title'),
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true,  
        });

      } finally {
        this.$emit('update:loadingUpdate', false);
      }
    },
  }
}
</script>